import { Controller } from '@hotwired/stimulus'

// Story-page CTA upgrade for GUESTS: when localStorage holds a reading
// position for this story, "Start reading" becomes "Continue reading" pointing
// at the saved chapter, with a small "Chapter N" hint beside it. Signed-in
// users get the same server-rendered (StoriesController preloads their
// progress row), so this controller is only rendered for anonymous visitors.
// Progressive enhancement: without JS/localStorage the default CTA stands.
const STORE_PREFIX = 'dh:read:v1:'

export default class extends Controller {
  static targets = ['link', 'label', 'hint']
  static values = {
    storyId: String,
    continueLabel: String,
    chapterHint: String // "Chapter %{number}" already translated
  }

  connect() {
    let entry
    try {
      const raw = localStorage.getItem(STORE_PREFIX + this.storyIdValue)
      entry = raw ? JSON.parse(raw) : null
    } catch {
      return
    }
    if (!entry || !entry.path) return

    if (this.hasLinkTarget) this.linkTarget.setAttribute('href', entry.path)
    if (this.hasLabelTarget) this.labelTarget.textContent = this.continueLabelValue
    if (this.hasHintTarget && entry.pos) {
      this.hintTarget.textContent = this.chapterHintValue.replace('%{number}', entry.pos)
      this.hintTarget.hidden = false
    }
  }
}
